// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__10UeP","bot-logo":"Navbar_bot-logo__QcC1d"};